import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {getRegistrationUpdateStatus} from '../../services/getRegistrationUpdateStatus';
import {UseGetRegistrationUpdateStatusQueryParams} from './types';

export const useGetRegistrationUpdateStatusQuery = ({
	enabled,
}: UseGetRegistrationUpdateStatusQueryParams = {}) =>
	useQuery({
		queryKey: [QUERY_KEYS.REGISTRATION_UPDATE_STATUS],
		queryFn: ({signal}) => getRegistrationUpdateStatus({signal}),
		enabled,
	});
